import React from "react";
import "./../../A2Page/A2Page.css";
import C2WhyHead from "./C2WhyHead";
import C2WhyMain from "./C2WhyMain";
const C2Why = () => {
  return (
    <div className="a2WhyContainer">
      <C2WhyHead />
      <C2WhyMain />
    </div>
  );
};

export default C2Why;
